<prism-card shAgGridAutoSizeContainer [ngClass]="[cardClass(), gridThemeClass()]" [gridApi]="gridApi()">
	<!-- Table header with progress indicator support -->
	<ng-content select="[tableHeader]"></ng-content>

	<!-- Table content (ag-grid or other table implementation) -->
	<ng-content select="[tableContent]"></ng-content>
</prism-card>
